import { ButtonLocation } from '../types';

export enum DataLayerLinkName {
  buttonNewAd = 'buttonNewAd'
}

interface DataLayerLinkData {
  value: string;
  timestamp: number;
  param: string;
}

export const setDataLayerEventForLinkElement = (
  linkName: DataLayerLinkName,
  value: string,
  param: string
): void => {
  if (typeof window === 'undefined' || !window.sessionStorage) return;

  const data: DataLayerLinkData = { value, timestamp: Date.now(), param };
  window.sessionStorage.setItem(linkName, JSON.stringify(data));
};

export const pushDataLayerEvent = (
  event: string,
  param: string,
  value: string
): void => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, [param]: value });
  }
};

export const pushLinkElementDataLayerEvent = (
  linkName: DataLayerLinkName
): void => {
  if (typeof window === 'undefined' || !window.sessionStorage) return;

  const raw = window.sessionStorage.getItem(linkName);
  if (!raw) return;

  try {
    const { timestamp, param, value } = JSON.parse(raw) as DataLayerLinkData;
    if (Date.now() - timestamp < 10000 && window.dataLayer)
      pushDataLayerEvent(linkName, param, value);
  } catch (error) {
    console.error(`Failed to parse ${linkName} from sessionStorage`, error);
  } finally {
    window.sessionStorage.removeItem(linkName);
  }
};

export const setButtonNewAdEvent = (buttonLocation: ButtonLocation) =>
  setDataLayerEventForLinkElement(
    DataLayerLinkName.buttonNewAd,
    buttonLocation,
    'buttonLocation'
  );

export const pushButtonNewAdDataLayerEvent = () =>
  pushLinkElementDataLayerEvent(DataLayerLinkName.buttonNewAd);
